import { styled } from '@mui/material'

export const Text = styled('span')({
  color: '#7B7B7B',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '19px',
})
